if (!customElements.get('cinoton-mega-catalog')) {
  class CinotonMegaCatalog extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('cinoton-mega--catalog')) return;
      this.triggers = [...this.querySelectorAll('[data-cinoton-catalog-trigger]')];
      this.panels = [...this.querySelectorAll('[data-cinoton-catalog-panel]')];
      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('pointerenter', () => this.activate(trigger.dataset.cinotonCatalogTrigger));
        trigger.addEventListener('focus', () => this.activate(trigger.dataset.cinotonCatalogTrigger));
        trigger.addEventListener('keydown', (event) => {
          if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowDown') next = (index + 1) % this.triggers.length;
          if (event.key === 'ArrowUp') next = (index - 1 + this.triggers.length) % this.triggers.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.triggers.length - 1;
          this.triggers[next].focus();
        });
      });
      if (this.triggers.length) this.activate(this.triggers[0].dataset.cinotonCatalogTrigger);
    }

    activate(id) {
      this.triggers.forEach((trigger) => {
        const active = trigger.dataset.cinotonCatalogTrigger === id;
        trigger.classList.toggle('is-active', active);
        trigger.setAttribute('aria-expanded', String(active));
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.cinotonCatalogPanel !== id;
      });
    }
  }
  customElements.define('cinoton-mega-catalog', CinotonMegaCatalog);
}
